import { useRef, useState } from 'react';
import moment from 'moment';

// 自定义hook：用于处理minReleaseTimeRef和maxReleaseTimeRef相关逻辑

export const useReleaseTime = (params: any) => {

  const [minReleaseTime, setMinReleaseTime] = useState('');
  const [maxReleaseTime, setMaxReleaseTime] = useState('');

  const onFetchSuccess = (minReleaseTime: string, maxReleaseTime: string) => {
    setMinReleaseTime(minReleaseTime);
    setMaxReleaseTime(maxReleaseTime);
  };

  const disabledDate = (date: moment.Moment) => {
    // 选择范围在今天之前，且选择跨度不大于七天
    const isAfterToday = date.isAfter(moment(minReleaseTime), 'day');
    const isBeforeToday = date.isBefore(
      moment(maxReleaseTime),
      'day',
    );
    return !(isAfterToday || isBeforeToday);
  };

  const getAllCompaniesFilterParams = () => {
    return {
      // getFetchParams: () => {
      //   return companyFilterParams || {};
      // },
      onFetchSuccess: onFetchSuccess,
    }
  }

  return { minReleaseTime, maxReleaseTime, disabledDate, getAllCompaniesFilterParams };

};